var isType = require('./isType');

module.exports = function isStruct(x) {
  return isType(x) && ( x.meta.kind === 'struct' );
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb-form/~/tcomb/lib/isStruct.js
 ** module id = 499
 ** module chunks = 0
 **/